import React, { useState } from "react";
import CustomRangeSlider from "components/CustomRangeSlider";

export default ({ questionCount, setQuestionReviews, questionReviews }) => {
  const [staticQuestion] = useState([
    { label: "Where do you think you stand now?", id: 1, name: "q1", value: 0 },
    {
      label: "Where do you think you will stand about five years from now?",
      id: 2,
      name: "q2",
      value: 0,
    },
  ]);
  const setQuestionResponse = (value, name) => {
    setQuestionReviews(
      questionReviews.filter((item) => item.id === questionCount)?.length > 0
        ? questionReviews.slice().map((data) => {
            if (data.id === questionCount) {
              return {
                ...data,
                [name]: value,
              };
            }
            return data;
          })
        : [...questionReviews, { id: questionCount, [name]: value }]
    );
  };
  return (
    <>
      <div className="assessmentReviews">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-lg-12 assessmentReviewSlider">
            <label>{staticQuestion[0].label}</label>
            <div className="formGroup">
              <CustomRangeSlider
                minValue={0}
                maxValue={100}
                steps={10}
                trackStyle={{ backgroundColor: "rgb(255, 161, 0)" }}
                dotStyle={{ borderColor: "rgb(255, 161, 0)" }}
                activeDotStyle={{
                  borderColor: "rgb(255, 161, 0)",
                  width: "10px",
                  height: "10px",
                  bottom: "-3px",
                  backgroundColor: "rgb(255, 161, 0)",
                }}
                handleStyle={{
                  border: "solid 2px rgb(255, 161, 0)",
                  backgroundColor: "rgb(255, 161, 0)",
                }}
                marks={{
                  0: 0,
                  10: 10,
                  20: 20,
                  30: 30,
                  40: 40,
                  50: 50,
                  60: 60,
                  70: 70,
                  80: 80,
                  90: 90,
                  100: 100,
                }}
                style={{ height: "40px" }}
                name={staticQuestion[0].name}
                value={
                  questionReviews[questionCount - 1]
                    ? questionReviews[questionCount - 1][staticQuestion[0].name]
                    : 0
                }
                onChange={(value) =>
                  setQuestionResponse(value, staticQuestion[0].name)
                }
              />
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 assessmentReviewSlider">
            <label>{staticQuestion[1].label}</label>
            <div className="formGroup">
              <CustomRangeSlider
                minValue={0}
                maxValue={100}
                steps={10}
                trackStyle={{ backgroundColor: "rgb(255, 161, 0)" }}
                dotStyle={{ borderColor: "rgb(255, 161, 0)" }}
                activeDotStyle={{
                  borderColor: "rgb(255, 161, 0)",
                  width: "10px",
                  height: "10px",
                  bottom: "-3px",
                  backgroundColor: "rgb(255, 161, 0)",
                }}
                handleStyle={{
                  border: "solid 2px rgb(255, 161, 0)",
                  backgroundColor: "rgb(255, 161, 0)",
                }}
                marks={{
                  0: 0,
                  10: 10,
                  20: 20,
                  30: 30,
                  40: 40,
                  50: 50,
                  60: 60,
                  70: 70,
                  80: 80,
                  90: 90,
                  100: 100,
                }}
                style={{ height: "40px" }}
                name={staticQuestion[1].name}
                value={
                  questionReviews[questionCount - 1]
                    ? questionReviews[questionCount - 1][staticQuestion[1].name]
                    : 0
                }
                onChange={(value) =>
                  setQuestionResponse(value, staticQuestion[1].name)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
